var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeptBlackIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 15,
    viewBox: "0 0 53 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4751 7.34129C13.4751 3.61908 11.4431 0.751465 6.27754 0.751465H0.751221V13.9311H6.27754C11.4431 13.9311 13.4751 11.0635 13.4751 7.34129ZM9.71489 7.34129C9.71489 9.94303 8.2526 10.9116 6.22061 10.9116H4.34049V3.77101H6.22061C8.2526 3.77101 9.71489 4.73954 9.71489 7.34129Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3347 13.9311H24.7797V10.9306H17.924V8.67068H23.9441V5.82201H17.924V3.75202H24.6088V0.751465H14.3347V13.9311Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9384 5.32827C36.9384 2.00486 34.8114 0.751465 31.507 0.751465H25.7908V13.9311H29.38V9.90508H31.507C34.8114 9.90508 36.9384 8.65165 36.9384 5.32827ZM33.2162 5.32827C33.2162 6.61965 32.6085 7.1514 31.1462 7.1514H29.38V3.50514H31.1462C32.6085 3.50514 33.2162 4.03688 33.2162 5.32827Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3302 3.82798H41.4892V13.9311H45.0784V3.82798H49.2374V0.751465H37.3302V3.82798Z",
    fill: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.746 12.0856C47.746 13.2783 48.7115 14.2438 49.9043 14.2438C51.0969 14.2438 52.072 13.2783 52.072 12.0856C52.072 10.8929 51.0969 9.91797 49.9043 9.91797C48.7115 9.91797 47.746 10.8929 47.746 12.0856ZM48.1625 12.0856C48.1625 11.1012 48.9386 10.2966 49.9043 10.2966C50.8695 10.2966 51.6554 11.1012 51.6554 12.0856C51.6554 13.07 50.8695 13.8652 49.9043 13.8652C48.9386 13.8652 48.1625 13.07 48.1625 12.0856ZM48.8913 13.1553H49.5727V12.4169H49.9611L50.3679 13.1553H51.1063L50.614 12.2844C50.8414 12.1898 51.0114 11.9342 51.0114 11.6502C51.0114 11.1485 50.6896 10.9119 50.1405 10.9119H48.8913V13.1553ZM50.3204 11.6596C50.3204 11.8395 50.2073 11.9153 49.9893 11.9153H49.5727V11.4419H49.9893C50.2073 11.4419 50.3204 11.4988 50.3204 11.6596Z",
    fill: "#0E0E0E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.8237,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeptBlackIcon);
export default __webpack_public_path__ + "static/media/DEPT-black-icon.065501f86d46f648070c0d79f9572acd.svg";
export { ForwardRef as ReactComponent };